import React from 'react'
import './AboutISBA.css'
import Footer from '../Footer'

import '../../App.css'




function Addition() {
    return (
        <div>
            <h1>This is an addition page</h1>
            <p>Hello</p>
        </div>
    )
}

export default Addition